module.exports = __webpack_public_path__ + "img/265.df09ff7b.gif";